import { useQuery } from '@tanstack/react-query';
import { expertProfileApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';

export function useExpertProfile(id: string) {
  return useQuery({
    queryKey: queryKeys.expertProfiles.detail(id),
    queryFn: () => expertProfileApi.getExpertProfile(id),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    retry: 1,
  });
}
